module.exports = __webpack_public_path__ + "img/post.efa3c9b7.png";